import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['select'];

    changeRegion() {
        window.location.href = this.selectTarget.value;
    }
}
